export default __webpack_public_path__ + "static/media/ONeutral.1578d8f4.svg";